import { render, staticRenderFns } from "./indica-list.vue?vue&type=template&id=7b95aa3b&"
import script from "./indica-list.vue?vue&type=script&lang=js&"
export * from "./indica-list.vue?vue&type=script&lang=js&"
import style0 from "./indica-list.vue?vue&type=style&index=0&id=7b95aa3b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports